export default function AboutSection() {
  const stats = [
    { value: '5年+', label: '稳定运营' },
    { value: '1000万+', label: '月活用户' },
    { value: '10万+', label: '影视资源' },
    { value: '99.9%', label: '服务可用率' },
  ];

  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-white rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="flex-1 p-8 md:p-12">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
                关于我们
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                农民影视成立于2021年，是国内领先的免费高清影视在线观看平台。我们致力于为全国用户提供免费高清电影与电视剧免费全集资源，让每一位观众都能轻松畅享高质量的影视内容。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                平台汇聚了涵盖动作、喜剧、爱情、科幻、悬疑、纪录片、动漫等全品类的高清影视资源，采用先进的流媒体传输技术，实现高清流畅播放不缓冲的优质体验。我们的内容运营团队每日追踪最新影视动态，确保用户第一时间观看到最新更新的电影和电视剧。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们始终坚持以用户体验为核心，不断优化播放技术与内容品质，努力打造用户最信赖的免费高清影视在线观看平台。
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center p-3 rounded-xl bg-background-100">
                    <div className="text-lg md:text-xl font-heading text-primary-600">{stat.value}</div>
                    <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-1 min-h-64 lg:min-h-0">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20modern%20creative%20office%20workspace%20with%20cinematic%20lighting%2C%20movie%20posters%20and%20film%20equipment%20as%20decor%2C%20golden%20amber%20and%20soft%20brown%20tones%2C%20elegant%20professional%20atmosphere%2C%20cozy%20creative%20vibe%2C%20no%20people%2C%20cinematic%20composition&width=800&height=600&seq=about-brand-image&orientation=landscape"
                alt="农民影视品牌介绍"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}